import { useEffect } from 'react';
import { TITLE_ALERT_PERIOD_MS, alertTitle } from './title-alert';

// Renames the tab back and forth while `active`, restoring the title it started with.
//
// The tick is a closure local, not state: as a dependency it would rebuild the interval
// once a second, taking the capture and restore with it, and read off a ref it would sit
// at zero and rename nothing.
export function useTitleAlert(active: boolean, alert: string): void {
  useEffect(() => {
    if (!active) return;
    const base = document.title;

    let tick = 0;
    const id = window.setInterval(() => {
      tick += 1;
      document.title = alertTitle(base, alert, tick);
    }, TITLE_ALERT_PERIOD_MS);

    return () => {
      window.clearInterval(id);
      document.title = base;
    };
  }, [active, alert]);
}
